module.exports = {
  apiUrl: process.env.NODE_ENV === 'production' ? location.protocol + '//tenagapintar.com/api' : 'https://api-energy.muhamadamin.com',
  apiRequestInterval: 300000, /* in miliseconds */
  loading: false
}
